import {HostListener, Injectable, OnInit} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutManagerService {

  public innerWidth;
  public innerHeigth;
  public mobileMode: boolean;
  public smallMode: boolean;

  constructor( ) { }

  updateSizes(width, heigth) {
    this.innerWidth = width;
    this.innerHeigth = heigth;
    if (innerWidth < 1100)
      this.mobileMode = true;
    else
      this.mobileMode = false;
    if (innerWidth < 480)
      this.smallMode = true;
    else
      this.smallMode = false;
  }
}
